// Блок 8: Тарифы — 3 колонки, Growth выделен

import { Button } from '../ui/Button';

interface Plan {
  name: string;
  price: string;
  description: string;
  features: string[];
  cta: string;
  highlighted: boolean;
}

const plans: Plan[] = [
  {
    name: 'Starter',
    price: '2 990',
    description: 'Для небольших команд',
    features: [
      '200 диалогов / мес',
      '1 канал',
      '2 оператора',
      '50 документов знаний',
      'Email-поддержка',
    ],
    cta: 'Попробовать бесплатно',
    highlighted: false,
  },
  {
    name: 'Growth',
    price: '7 990',
    description: 'Для растущего бизнеса',
    features: [
      '1 000 диалогов / мес',
      '3 канала',
      '5 операторов',
      '200 документов знаний',
      'Приоритетная поддержка',
    ],
    cta: 'Начать 14 дней бесплатно',
    highlighted: true,
  },
  {
    name: 'Business',
    price: '19 990',
    description: 'Для крупных компаний',
    features: [
      '5 000 диалогов / мес',
      'Безлимитные каналы',
      'Безлимитные операторы',
      'Безлимитная база знаний',
      'Выделенный менеджер',
    ],
    cta: 'Попробовать бесплатно',
    highlighted: false,
  },
];

export function PricingSection(): JSX.Element {
  return (
    <section id="pricing" className="py-20 lg:py-28 bg-surface-base">
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <h2 className="font-heading text-3xl sm:text-4xl font-extrabold text-text-primary tracking-tight">
            Тарифы
          </h2>
          <p className="mt-4 text-text-secondary text-base sm:text-lg leading-relaxed">
            Дешевле, чем нанять ещё одного оператора. 14&nbsp;дней Growth бесплатно.
            Без привязки карты.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {plans.map((plan) => (
            <div
              key={plan.name}
              className={`relative flex flex-col rounded-panel border p-7 transition-shadow ${
                plan.highlighted
                  ? 'bg-white border-accent-brand shadow-medium ring-1 ring-accent-brand/20'
                  : 'bg-white border-border-subtle hover:shadow-medium'
              }`}
            >
              {plan.highlighted && (
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-accent-brand text-white text-[11px] font-bold px-3 py-0.5 rounded-full">
                  Популярный
                </span>
              )}

              <div className="mb-6">
                <h3 className="font-heading text-lg font-bold text-text-primary">{plan.name}</h3>
                <p className="text-sm text-text-secondary mt-0.5">{plan.description}</p>
                <div className="mt-4 flex items-baseline gap-1">
                  <span className="font-heading text-3xl font-extrabold text-text-primary">{plan.price}&nbsp;₽</span>
                  <span className="text-sm text-text-muted">/ мес</span>
                </div>
              </div>

              <ul className="flex-1 space-y-3 mb-7">
                {plan.features.map((f) => (
                  <li key={f} className="flex items-start gap-2 text-sm text-text-secondary">
                    <svg className="w-4 h-4 text-accent-success flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                    </svg>
                    {f}
                  </li>
                ))}
              </ul>

              <Button variant={plan.highlighted ? 'primary' : 'secondary'} size="lg" className="w-full">
                {plan.cta}
              </Button>
            </div>
          ))}
        </div>

        <p className="mt-8 text-center text-xs text-text-muted">
          Дополнительные диалоги: 15&nbsp;₽ / диалог
        </p>
      </div>
    </section>
  );
}
